<div
  class="flex nordic-blue-900-text text-icon-primary pr-medium-b font-body-1 font-body-medium"
  *ngIf="additionalInfoKey$ | async"
>
  <div class="flex--nogrow">
    <fcom-icon class="icon-small" [name]="SvgLibraryIcon.INFO" />
  </div>
  <div class="flex-1 ps-xsmall-l">
    {{ additionalInfoKey$ | async | finLocalization }}
  </div>
</div>
